import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"สัญญาไม่เปิดเผยข้อมูล (NDA) — Bilingual Thailand-Global","metaTitle":"ร่าง NDA ไทย-อังกฤษ — Mutual, One-way, Multi-party | NYC","metaDesc":"ร่างสัญญาไม่เปิดเผยข้อมูล (NDA/CDA) 2 ภาษา บังคับใช้ตาม พ.ร.บ.ความลับทางการค้า 2545 พร้อมโนตารีสำหรับสัญญาข้ — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Non-Disclosure Agreement (NDA) — Bilingual Thailand-Global","metaTitle":"Thai NDA Drafting — Mutual, One-way, Multi-party, Bilingual | NYC","metaDesc":"Thai-English NDAs enforceable under the Trade Secrets Act B.E. 2545 with notarisation for cross-border de — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/legal/contract/nda")({
  head: () => {
    const url = `${SEO_SITE}/legal/contract/nda`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/legal/contract/nda", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/legal/contract/nda", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/legal/contract/nda", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/legal/contract/nda", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/legal/contract/nda", "/en/legal/contract/nda")],
    };
  },
  component: () => <SubServicePage slug="legal/contract/nda" locale="th" />,
});
